import { Loader2 } from 'lucide-react';
import React from 'react';

function Loading() {
  return (
    <Loader2 className="animate-spin" />
  );
}

export default Loading;
